<template>
  <div>
    <v-app id="inspire">
      <!-- sidebar starts -->
      <v-app-bar app class="nav custom-header" dark>
        <v-row no-gutters align="center" class="mt-sm-0 mt-md-0">
          <v-col cols="4" md="4" sm="4" class="ml-md-n0 ml-sm-n8 ml-n3">
            <v-img
                src="/img/fantasy_lineups_logo.png"
                class="logo"
                width="330px"
                contain
            />
          </v-col>

          <v-spacer></v-spacer>

          <v-col
              cols="3"
              md="1"
              sm="2"
              class="ml-md-n4 ml-sm-5 mt-6 cus-nav-select"
          >
            <!--//? sport type -->
            <v-select
                class="sports float-md-right float-sm-none mx-auto"
                light
                :items="sport"
                item-text="SportType"
                item-value="SportId"
                solo
                dense
                v-model="formValue.defaultSport.SportId"
                @change="filterGame(formValue.defaultSport.SportId)"
            >
              <template v-slot:item="{ item }">
                <small class="body-2">
                  {{ item.SportType }}
                  <v-icon small class="ml-1" v-if="item.SportId == 1"
                  >mdi-basketball
                  </v-icon
                  >
                  <v-icon small class="ml-1" v-if="item.SportId == 2"
                  >mdi-baseball
                  </v-icon
                  >
                  <v-icon small class="ml-1" v-if="item.SportId == 3"
                  >mdi-hockey-sticks
                  </v-icon
                  >
                  <v-icon small class="ml-1" v-if="item.SportId == 4"
                  >mdi-football
                  </v-icon
                  >
                </small>
              </template>
            </v-select>
            <!--//? sport type ends-->
            <!-- <p>{{ formValue.defaultSport.SportType }}</p> -->
          </v-col>

          <v-col cols="3" md="2" sm="2">
            <!--//? optimizer selection -->
            <v-select
                class="mt-6 ml-md-2 ml-sm-n3 optimizer cus-nav-select"
                :items="SlateData"
                item-text="Operator"
                item-value="Operator"
                :disabled="isDisable"
                light
                dense
                solo
                v-model="formValue.defaultOptimizer.Operator"
                @change="
                filterOperator($event, formValue.defaultOptimizer.Operator)
              "
            ></v-select>
            <!--//? optimizer selection ends-->
          </v-col>
          <v-spacer></v-spacer>

          <!-- //! for laptop view...  -->
          <template v-if="$vuetify.breakpoint.mdAndUp">
            <!-- date -->
            <v-col cols="2" md="2" sm="2" class="text-sm-center">
              <!-- <p class="overline mt-4" style="vertical-align:middle"></p> -->
              <small class="ml-sm-n1 font-weight-light">
                <span class="black--white caption"> Date: </span>&nbsp;
                {{ this.formValue.defaultDate }}
              </small>
            </v-col>
            <!-- date -->

            <!--//? bell icon -->
            <!-- <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on">
                  <v-icon>mdi-bell</v-icon>
                </v-btn>
              </template>
              <span>Notification</span>
            </v-tooltip> -->
            <!--//? bell icon end -->

            <!--//? profile image -->
            <!-- <v-avatar size="36">
              <img src="https://cdn.vuetifyjs.com/images/john.jpg" alt="John" />
            </v-avatar> -->
            <p class="caption mt-3 ml-2 text-center">{{ userName }}</p>
            <!-- //? profile image end -->

            <!-- profile list items -->
            <v-menu offset-y transition="slide-x-transition">
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" icon v-on="on">
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list style="max-height: 350px; overflow-x: scroll">
                <template v-if="paymentType == 'clickbank'">
                  <v-list-item
                      v-for="(detail, index) in account"
                      :key="index"
                      :href="detail.to[1]"
                      exact
                      class="mb-n5"
                      router
                  >
                    <v-list-item-icon>
                      <v-icon>{{ detail.icon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-subtitle>
                      {{ detail.title }}
                    </v-list-item-subtitle>
                  </v-list-item>
                </template>

                <template v-else>
                  <v-list-item
                      v-for="(detail, index) in account"
                      :key="index"
                      :href="detail.to[0]"
                      exact
                      class="mb-n5"
                      router
                  >
                    <v-list-item-icon>
                      <v-icon>{{ detail.icon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-subtitle>
                      {{ detail.title }}
                    </v-list-item-subtitle>
                  </v-list-item>
                </template>

                <!-- billing -->
                <v-list-item
                    @click="userBilling"
                    class="mb-n3"
                    v-if="role === 'user'"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-account</v-icon>
                  </v-list-item-icon>
                  <v-list-item-subtitle>Account Info</v-list-item-subtitle>
                </v-list-item>
                <!-- billing -->

                <!-- Cancel -->
                <v-list-item @click="cancelModal">
                  <v-list-item-icon>
                    <v-icon>mdi-account-cancel-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-subtitle>Cancel Sub</v-list-item-subtitle>
                </v-list-item>
                <!-- Cancel -->

                <!-- setting -->
                <v-list-item
                    v-if="role !== 'user'"
                    @click="managerSetting"
                    class="mb-n3"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-cog-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-subtitle>Settings</v-list-item-subtitle>
                </v-list-item>
                <!-- setting -->

                <!-- report -->
                <v-list-item
                    v-if="role == 'client'"
                    @click="goToReport"
                    class="mb-n3"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-file-document-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-subtitle>Report</v-list-item-subtitle>
                </v-list-item>
                <!-- report -->

                <!-- All users -->
                <v-list-item
                    @click="goToUsers"
                    class="mt-n3 mb-n3"
                    v-if="role !== 'user'"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-account-group-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-subtitle>Users</v-list-item-subtitle>
                </v-list-item>
                <!-- All users -->

                <!--users login report-->
                <v-list-item
                    @click="goToUserLoginHistory"
                    v-if="role !== 'user'"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-history</v-icon>
                  </v-list-item-icon>
                  <v-list-item-subtitle>Login Report</v-list-item-subtitle>
                </v-list-item>
                <!-- users login report ends... -->

                <!--best bet-->
                <v-list-item @click="goToUserBestBet" v-if="role !== 'user'">
                  <v-list-item-icon>
                    <v-icon>mdi-podium</v-icon>
                  </v-list-item-icon>
                  <v-list-item-subtitle>Best Bet</v-list-item-subtitle>
                </v-list-item>
                <!--best bet ends-->

                <!--articles-->
                <v-list-item @click="goToArticleForm" v-if="role !== 'user'">
                  <v-list-item-icon>
                    <v-icon>mdi-newspaper</v-icon>
                  </v-list-item-icon>
                  <v-list-item-subtitle>Articles</v-list-item-subtitle>
                </v-list-item>
                <!--articles ends-->

                <!-- logout -->
                <v-list-item @click="logout" class="mt-n3">
                  <v-list-item-icon>
                    <v-icon>mdi-logout-variant</v-icon>
                  </v-list-item-icon>
                  <v-list-item-subtitle>Logout</v-list-item-subtitle>
                </v-list-item>
                <!-- logout -->
              </v-list>
            </v-menu>
          </template>

          <!-- //! for tabletview... -->
          <template v-if="$vuetify.breakpoint.smOnly">
            <!--//? date -->
            <v-col cols="2" md="2" sm="2" class="text-sm-center mr-10">
              <small class="font-weight-light">
                <span class="black--white caption"> Date: </span>&nbsp;
                {{ this.formValue.defaultDate }}
              </small>
            </v-col>
            <!--//? date -->

            <v-menu offset-y transition="slide-x-transition">
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" icon v-on="on" class="mr-1">
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list style="max-height: 350px; overflow-x: scroll">
                <!--  usename -->
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon>mdi-account</v-icon>
                  </v-list-item-icon>
                  <v-list-item-subtitle class="body-1 font-weight-black">{{
                      userName
                    }}
                  </v-list-item-subtitle>
                </v-list-item>
                <!--  -->

                <!-- billing -->
                <v-list-item @click="userBilling" v-if="role === 'user'">
                  <v-list-item-icon>
                    <v-icon>mdi-account</v-icon>
                  </v-list-item-icon>
                  <v-list-item-subtitle>Account Info</v-list-item-subtitle>
                </v-list-item>
                <!-- billing -->

                <!-- Cancel -->
                <v-list-item @click="cancelModal">
                  <v-list-item-icon>
                    <v-icon>mdi-account-cancel-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-subtitle>Cancel Sub</v-list-item-subtitle>
                </v-list-item>
                <!-- Cancel -->

                <!-- All users -->
                <v-list-item @click="goToUsers" v-if="role !== 'user'">
                  <v-list-item-icon>
                    <v-icon>mdi-account-group-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-subtitle>Users</v-list-item-subtitle>
                </v-list-item>
                <!-- All users -->

                <!--users login report-->
                <v-list-item
                    @click="goToUserLoginHistory"
                    v-if="role !== 'user'"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-history</v-icon>
                  </v-list-item-icon>
                  <v-list-item-subtitle>Login Report</v-list-item-subtitle>
                </v-list-item>
                <!-- users login report ends... -->

                <!--best bet-->
                <v-list-item @click="goToUserBestBet" v-if="role !== 'user'">
                  <v-list-item-icon>
                    <v-icon>mdi-podium</v-icon>
                  </v-list-item-icon>
                  <v-list-item-subtitle>Best Bet</v-list-item-subtitle>
                </v-list-item>
                <!--best bet ends-->

                <!--articles-->
                <v-list-item @click="goToArticleForm" v-if="role !== 'user'">
                  <v-list-item-icon>
                    <v-icon>mdi-newspaper-variant-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-subtitle>Articles</v-list-item-subtitle>
                </v-list-item>
                <!--articles ends-->

                <!-- logout -->
                <v-list-item @click="logout">
                  <v-list-item-icon>
                    <v-icon>mdi-logout-variant</v-icon>
                  </v-list-item-icon>
                  <v-list-item-subtitle>Logout</v-list-item-subtitle>
                </v-list-item>
                <!-- logout -->
              </v-list>
            </v-menu>
          </template>

          <!-- //! for mobile view... -->
          <template v-if="$vuetify.breakpoint.xsOnly">
            <v-col cols="1" md="2" sm="2">
              <v-menu offset-y transition="slide-x-transition">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" icon v-on="on">
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <v-list style="max-height: 350px; overflow-x: scroll">
                  <v-list-item
                      v-for="(detail, index) in account"
                      :key="index"
                      :href="detail.to[0]"
                      router
                  >
                    <v-list-item-icon>
                      <v-icon>{{ detail.icon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-subtitle>{{
                        detail.title
                      }}
                    </v-list-item-subtitle>
                  </v-list-item>

                  <!-- billing -->
                  <v-list-item @click="userBilling" v-if="role === 'user'">
                    <v-list-item-icon>
                      <v-icon>mdi-account</v-icon>
                    </v-list-item-icon>
                    <v-list-item-subtitle>Account Info</v-list-item-subtitle>
                  </v-list-item>
                  <!-- billing -->

                  <!-- Cancel -->
                  <v-list-item @click="cancelModal">
                    <v-list-item-icon>
                      <v-icon>mdi-account-cancel-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-subtitle>Cancel Sub</v-list-item-subtitle>
                  </v-list-item>
                  <!-- Cancel -->

                  <!-- All users -->
                  <v-list-item @click="goToUsers" v-if="role !== 'user'">
                    <v-list-item-icon>
                      <v-icon>mdi-account-group-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-subtitle>Users</v-list-item-subtitle>
                  </v-list-item>
                  <!-- All users ends..-->

                  <!--users login report-->
                  <v-list-item
                      @click="goToUserLoginHistory"
                      v-if="role !== 'user'"
                  >
                    <v-list-item-icon>
                      <v-icon>mdi-history</v-icon>
                    </v-list-item-icon>
                    <v-list-item-subtitle>Login Report</v-list-item-subtitle>
                  </v-list-item>
                  <!-- users login report ends... -->

                  <!--best bet-->
                  <v-list-item @click="goToUserBestBet" v-if="role !== 'user'">
                    <v-list-item-icon>
                      <v-icon>mdi-podium</v-icon>
                    </v-list-item-icon>
                    <v-list-item-subtitle>Best Bet</v-list-item-subtitle>
                  </v-list-item>
                  <!--best bet ends-->

                  <!--articles-->
                  <v-list-item @click="goToArticleForm" v-if="role !== 'user'">
                    <v-list-item-icon>
                      <v-icon>mdi-newspaper-variant-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-subtitle>Articles</v-list-item-subtitle>
                  </v-list-item>
                  <!--articles ends-->

                  <!-- logout -->
                  <v-list-item @click="logout">
                    <v-list-item-icon>
                      <v-icon>mdi-logout-variant</v-icon>
                    </v-list-item-icon>
                    <v-list-item-subtitle>Logout</v-list-item-subtitle>
                  </v-list-item>
                  <!-- logout -->
                </v-list>
              </v-menu>
            </v-col>
          </template>
        </v-row>

        <!-- profile list items end -->

        <!--main tab starts-->
        <template v-slot:extension>
          <v-tabs v-model="tab" centered :hide-slider="true">
            <v-tabs-slider color="green"></v-tabs-slider>

            <!-- //todo NBA.. -->
            <template v-if="formValue.defaultSport.SportId == '1'">
              <v-tab exact @click="isDisable = false" :to="{ name: 'NbaNews' }">
                Insights
              </v-tab>

              <v-tab
                  exact
                  @click="isDisable = false"
                  :to="{ name: 'nbaPositionOpti' }"
              >
                Optimizer
              </v-tab>

              <v-tab exact :to="{ name: 'NbaProjection' }">
                Betting Tools
              </v-tab>
            </template>

            <!-- //todo MLB.. -->
            <template v-else-if="formValue.defaultSport.SportId == '2'">
              <v-tab exact @click="isDisable = false" :to="{ name: 'MlbNews' }">
                Insights
              </v-tab>

              <v-tab
                  exact
                  @click="isDisable = false"
                  :to="{ name: 'MlbPositionOpti' }"
              >
                Optimizer
              </v-tab>

              <v-tab exact :to="{ name: 'MlbProjection' }">
                Betting Tools
              </v-tab>
            </template>

            <!-- //todo NHL.. -->
            <template v-else-if="formValue.defaultSport.SportId == '3'">
              <v-tab exact @click="isDisable = false" :to="{ name: 'NhlNews' }">
                Insights
              </v-tab>

              <v-tab
                  exact
                  @click="isDisable = false"
                  :to="{ name: 'NhlPositionOpti' }"
              >
                Optimizer
              </v-tab>

              <v-tab exact :to="{ name: 'NhlProjection' }">
                Betting Tools
              </v-tab>
            </template>

            <!-- //todo NFL.. -->
            <template v-else-if="formValue.defaultSport.SportId == '4'">
              <v-tab
                  exact
                  @click="isDisable = false"
                  :to="{ name: 'NflBrowseTeam' }"
              >
                Insights
              </v-tab>

              <v-tab
                  exact
                  @click="isDisable = false"
                  :to="{ name: 'NflPositionOpti' }"
              >
                Optimizer
              </v-tab>

              <v-tab exact :to="{ name: 'NflProjection' }">
                Betting Tools
              </v-tab>
            </template>
          </v-tabs>
        </template>
        <!--main tab ends-->
      </v-app-bar>

      <!-- content -->

      <v-main class="mt-n3">
        <v-tabs-items>
          <!-- <transition
            mode="out-in"
            enter-active-class="animate__animated animate__fadeIn animate__faster"
            leave-active-class="animate__animated animate__fadeOut animate__faster"
          > -->
          <router-view
              :allSlate="operatorWiseSlate"
              :key="$route.fullPath"
              :defaultSport="formValue.defaultSport.SportId"
              :defaultOptimizer="formValue.defaultOptimizer.Operator"
              :slateStatus="slateStatus"
              :planType="userState.plantype"
          ></router-view>
          <!-- </transition> -->
        </v-tabs-items>
      </v-main>
    </v-app>

    <!-- cancel subs popup -->
    <v-dialog v-model="subsDialog" max-width="450px">
      <v-card>
        <v-form>
          <div align="center">
            <v-col cols="12" md="12" sm="12" align="center">
              <p class="body-1 pa-1 red--text font-weight-bold">
                Are you sure you want to Cancel Subscription ?
              </p>
            </v-col>
          </div>

          <!-- //* button -->
          <div align="center" class="mt-n5">
            <v-col cols="12" md="8" sm="12" class="mt-n7">
              <v-btn block color="warning" @click="cancelSubs" class="mr-4">
                <v-progress-circular
                    v-if="buttonLoader"
                    indeterminate
                    :width="3"
                    color="success"
                    size="20"
                ></v-progress-circular>
                Confirm
              </v-btn>
            </v-col>
          </div>

          <v-col cols="12" md="12" align="center" class="mt-n4">
            <v-btn color="blue darken-1" text @click="closeDelete"
            >Cancel
            </v-btn
            >
          </v-col>
        </v-form>
      </v-card>
    </v-dialog>
    <!-- cancel subs popup -->
  </div>
</template>

<script>
import axios from "axios";

import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import _ from "lodash";
import {mapGetters, mapState} from "vuex";

export default {
  name: "NbaNavbar",
  title: "Fantasy Lineups Analyzer",

  data: () => ({
    isDisable: false,
    userName: localStorage.getItem("userName"),
    role: localStorage.getItem("role"),
    paymentType: localStorage.getItem("paymentType"),
    userId: localStorage.getItem("user"),
    strip_customerID: localStorage.getItem("stripe_Subscription_id"),
    AllSlate: [],
    sport: [],
    tab: null,
    interval: null,
    operatorWiseSlate: [],
    slateStatus: true,
    subsDialog: false,
    buttonLoader: false,

    // sports: [
    //   { name: 'NBA', icon: 'mdi-basketball', id: '1' },
    //   { name: 'MLB', icon: 'mdi-baseball', id: '2' },
    //   { name: 'NHL', icon: 'mdi-hockey-sticks', id: '3' },
    //   { name: 'NFL', icon: 'mdi-football', id: '4' },
    // ],

    GameOperator: [{Operator: "DraftKings"}, {Operator: "FanDuel"}],

    formValue: {
      defaultSport: {
        SportId: "1",
        SportType: "NFL",
        disabled: false,
        status: 2,
      },
      defaultOptimizer: {Operator: "DraftKings"},
      defaultDate: "",
    },

    account: [
      {
        title: "Contact",
        icon: "mdi-email",
        to: ["/contact-us", "/click/contact-us"],
      },
      {
        title: "Reset Password",
        icon: "mdi-account-alert-outline",
        to: ["/recover-password"],
      },
    ],
  }),

  created() {
    // ? calling the all sports api...
    this.fetchAllSports();
  },

  beforeRouteUpdate(to, from, next) {
    if (this.formValue.defaultSport.SportId === "1") {
      this.$store.dispatch("NbaModule/getSlate").then(() => {
        this.AllSlate = [];
        this.AllSlate = this.$store.state.NbaModule.AllSlate;
        this.slateStatus = this.$store.state.NbaModule.status;
        this.filterOperatorforRoute(this.formValue.defaultOptimizer.Operator);

      });
      next();
    } else if (this.formValue.defaultSport.SportId === "2") {
      this.$store.dispatch("MlbModule/getSlate").then(() => {
        this.AllSlate = [];
        this.AllSlate = this.$store.state.MlbModule.AllSlate;
        this.slateStatus = this.$store.state.MlbModule.status;
        this.filterOperatorforRoute(this.formValue.defaultOptimizer.Operator);

      });
      next();
    } else if (this.formValue.defaultSport.SportId === "3") {
      this.$store.dispatch("NhlModule/getSlate").then(() => {
        this.AllSlate = [];
        this.AllSlate = this.$store.state.NhlModule.AllSlate;
        this.slateStatus = this.$store.state.NhlModule.status;
        this.filterOperatorforRoute(this.formValue.defaultOptimizer.Operator);
        //console.log('sports Nhl', this.AllSlate);
      });
      next();
    } else if (this.formValue.defaultSport.SportId === "4") {
      this.$store.dispatch("NflModule/getSlate").then(() => {
        this.AllSlate = [];
        this.AllSlate = this.$store.state.NflModule.AllSlate;
        this.slateStatus = this.$store.state.NflModule.status;
        this.filterOperatorforRoute(this.formValue.defaultOptimizer.Operator);
        //console.log('sports Nfl', this.AllSlate);
      });
      next();
    } else next(false);
  },

  mounted() {
    window.onpopstate = () => {
      const loggedIn = localStorage.getItem("user");
      const PaymentStatus = localStorage.getItem("status");
      if (loggedIn !== null && PaymentStatus == "active") {
        // this.$router.replace({ name: 'NbaLayout' }).catch(() => {});
        // this.$router.go();
        //console.log('forward', this.$router.currentRoute);
      } else return this.$router.replace({ name: 'Login' }).catch(() => {});
    };

    this.interval = setInterval(() => {
      this.currentDate();
    }, 1000);
  },

  computed: {
    ...mapState("NbaModule", ["portal"]),
    ...mapGetters("NbaModule", ["loadingStatus"]),
    ...mapState("userModule", ["userState"]),

    //? switch between slate arrays..
    SlateData() {
      if (!this.AllSlate.length) {
        return this.GameOperator;
      }
      return this.AllSlate;
    },
  },

  methods: {
    fetchAllSports() {
      axios
          .get("https://api.fantasylineups.com/user/getallsportslat")
          .then((response) => {
            let newSportData = response.data.data.map((item) => {
              return {
                SportId: item.SportId,
                SportType: item.SportType,
                status: item.status,
                disabled: item.status === 0,
              };
            });

            // ! fu***$# important piece of code...
            this.sport = _.orderBy(newSportData, ["status"], ["desc"]);
            // let index = this.sport.findIndex((sport) => {
            //   return sport.SportId === "2";
            // });

            // this.sport.splice(index, 1, {
            //   SportId: '2',
            //   SportType: 'MLB',
            //   status: 1,
            //   disabled: false,
            // });
            console.log({sport: this.sport});
            console.log(this.formValue.defaultSport);
          })
          .then(() => {
            //* this will call on the initial page loading after login...

            if (this.formValue.defaultSport.SportId == "1") {
              this.$store.dispatch("NbaModule/getSlate").then(() => {
                this.AllSlate = [];
                this.AllSlate = this.$store.state.NbaModule.AllSlate;
                this.slateStatus = this.$store.state.NbaModule.status;
              });
            } else if (this.formValue.defaultSport.SportId == "2") {
              this.$store.dispatch("MlbModule/getSlate").then(() => {
                this.AllSlate = [];
                this.AllSlate = this.$store.state.MlbModule.AllSlate;
                this.slateStatus = this.$store.state.MlbModule.status;
              });
            } else if (this.formValue.defaultSport.SportId == "3") {
              this.$store.dispatch("NhlModule/getSlate").then(() => {
                this.AllSlate = [];
                this.AllSlate = this.$store.state.NhlModule.AllSlate;
                this.slateStatus = this.$store.state.NhlModule.status;
              });
            } else if (this.formValue.defaultSport.SportId == "4") {
              this.$store.dispatch("NflModule/getSlate").then(() => {
                this.AllSlate = [];
                this.AllSlate = this.$store.state.NflModule.AllSlate;
                this.slateStatus = this.$store.state.NflModule.status;
              });
            }
            this.filterOperator(this.formValue.defaultOptimizer.Operator);
          })
          .catch((err) => console.log(err));
    },

    currentDate() {
      dayjs.extend(utc);
      dayjs.extend(timezone);

      this.formValue.defaultDate = dayjs()
          .utc()
          .tz("America/New_York")
          .format("MMM D, YYYY h:mm:ss A");
    },

    filterGame(gameId) {
      this.isDisable = false;

      if (gameId == "1") {
        this.$router
            .push(
                `/${this.formValue.defaultSport.SportId}/${this.formValue.defaultOptimizer.Operator}/insight/news-nba`
            )
            .catch(() => {
            });
      } else if (gameId == "2") {
        this.$router
            .push(
                `/${this.formValue.defaultSport.SportId}/${this.formValue.defaultOptimizer.Operator}/insight/news-mlb`
            )
            .catch(() => {
            });
      } else if (gameId == "3") {
        this.$router
            .push(
                `/${this.formValue.defaultSport.SportId}/${this.formValue.defaultOptimizer.Operator}/insight/news-nhl`
            )
            .catch(() => {
            });
      } else if (gameId == "4") {
        this.$router
            .push(
                `/${this.formValue.defaultSport.SportId}/${this.formValue.defaultOptimizer.Operator}/insight/teams-nfl`
            )
            .catch(() => {
            });
      }
    },

    filterOperator(operator) {
      if (!this.AllSlate.length) {
        let slate = this?.GameOperator.filter(
            (item) => item?.Operator == operator
        );

        localStorage.setItem(
            "gameOperator",
            this.formValue.defaultOptimizer.Operator
        );
        this.operatorWiseSlate = slate;
      }

      let slate = this?.AllSlate.filter((item) => item?.Operator == operator);
      localStorage.setItem(
          "gameOperator",
          this.formValue.defaultOptimizer.Operator
      );
      this.operatorWiseSlate = slate;

      if (this.formValue.defaultSport.SportId === "1") {
        this.$router
            .push(
                `/1/${this.formValue.defaultOptimizer.Operator}/insight/news-nba`
            )
            .catch(() => {
            });
      } else if (this.formValue.defaultSport.SportId === "2") {
        this.$router
            .push(
                `/2/${this.formValue.defaultOptimizer.Operator}/insight/news-mlb`
            )
            .catch(() => {
            });
      } else if (this.formValue.defaultSport.SportId == "3") {
        this.$router
            .push(
                `/3/${this.formValue.defaultOptimizer.Operator}/insight/news-nhl`
            )
            .catch(() => {
            });
      } else if (this.formValue.defaultSport.SportId == "4") {
        this.$router
            .push(
                `/4/${this.formValue.defaultOptimizer.Operator}/insight/teams-nfl`
            )
            .catch(() => {
            });
      }
    },

    filterOperatorforRoute(operator) {
      let slate = this.AllSlate.filter((item) => item?.Operator == operator);
      this.operatorWiseSlate = slate;
    },

    logout() {
      this.$store.dispatch("NbaModule/userLogout").then(() => {
        this.$router.push({name: "loginForm"});
      });
    },

    goToUsers() {
      this.$router.push({name: "allUsersTable"});
    },

    goToUserLoginHistory() {
      this.$router.push({name: "loginReport"});
    },

    async userBilling() {
      // if (this.userState.plantype === 'Free') {
      // await this.$router.push({name: 'upgradePlan'});
      // } else {
      let obj = {
        stripe_customer_id: localStorage.getItem("stripe_customer_id"),
      };
      await this.$store.dispatch("NbaModule/createPortal", obj);
      let path = this.portal.data.url;
      location.href = path;
      // }
    },

    managerSetting() {
      this.$router.push({name: "settings"});
    },

    goToReport() {
      this.$router.push({name: "reportTable"});
    },

    goToUserBestBet() {
      this.$router.push({name: "bestBetPage"});
    },

    goToArticleForm() {
      this.$router.push({name: "articlePage"});
    },

    cancelSubs() {
      this.buttonLoader = true;
      let obj = {
        stripe_subscription_id: this.strip_customerID,
        userId: this.userId,
      };
      this.$store.dispatch("NbaModule/cancelSubscription", obj).then(() => {
        this.logout();
      });
    },

    cancelModal() {
      this.subsDialog = true;
    },

    closeDelete() {
      this.subsDialog = false;
    },
  },

  beforeDestroy() {
    //console.log(this.interval);
    clearInterval(this.interval);
    //console.log('timer destroy');
  },
};
</script>

<style scoped>
.list {
  margin-left: 15px;
}

.list:hover {
  border-radius: 10px;
  box-shadow: 0 0 10px 0 #75f16a;
}

.v-list-item {
  margin: 10px 10px;
}

.sports {
  font-size: 0.8em;
  min-height: 10px;
  max-height: 60px;
  max-width: 90px;
}

.optimizer {
  font-size: 0.8em;
  min-height: 10px;
  max-height: 60px;
  max-width: 120px;
}

@media screen and (min-width: 767px) {
  .v-text-field.v-text-field--solo.v-input--dense > .v-input__control {
    min-height: 20px !important;
  }
}
</style>
